export interface BaseOption {
  key: number;
  value: number | string;
}

const BaseSelect: React.FC<{
  id: string;
  className?: string;
  value?: string | number;
  onChange: (e: any) => void;
  required?: boolean;
  options: BaseOption[];
}> = ({ className, id, value, onChange, required, options }) => {
  return (
    <select
      className={`control ${className ? className : ""}`}
      id={id}
      value={value}
      onChange={(e) => {
        onChange(Number(e.target.value));
      }}
      required={required || false}
    >
      {options.map((e) => (
        <option key={e.key} value={e.key}>
          {e.value}
        </option>
      ))}
    </select>
  );
};

export default BaseSelect;
